// @ts-nocheck

export const localeCodes =  [
  "da",
  "en"
]
export const localeLoaders = {
  da: [
    {
      key: "locale_da_46json_a8a64caf",
      load: () => import("#nuxt-i18n/a8a64caf" /* webpackChunkName: "locale_da_46json_a8a64caf" */),
      cache: true
    },
    {
      key: "locale_da_46json_3b3f3ae4",
      load: () => import("#nuxt-i18n/3b3f3ae4" /* webpackChunkName: "locale_da_46json_3b3f3ae4" */),
      cache: true
    },
    {
      key: "locale_da_46json_b38735bb",
      load: () => import("#nuxt-i18n/b38735bb" /* webpackChunkName: "locale_da_46json_b38735bb" */),
      cache: true
    },
    {
      key: "locale_da_46json_d344e06c",
      load: () => import("#nuxt-i18n/d344e06c" /* webpackChunkName: "locale_da_46json_d344e06c" */),
      cache: true
    },
    {
      key: "locale_da_46json_c2dc05e0",
      load: () => import("#nuxt-i18n/c2dc05e0" /* webpackChunkName: "locale_da_46json_c2dc05e0" */),
      cache: true
    },
    {
      key: "locale_i18n_45brand_46da_46json_fd46d3f6",
      load: () => import("#nuxt-i18n/fd46d3f6" /* webpackChunkName: "locale_i18n_45brand_46da_46json_fd46d3f6" */),
      cache: true
    },
    {
      key: "locale_da_46json_e41ec7ad",
      load: () => import("#nuxt-i18n/e41ec7ad" /* webpackChunkName: "locale_da_46json_e41ec7ad" */),
      cache: true
    },
    {
      key: "locale_da_46json_d0973c77",
      load: () => import("#nuxt-i18n/d0973c77" /* webpackChunkName: "locale_da_46json_d0973c77" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_fb361ab1",
      load: () => import("#nuxt-i18n/fb361ab1" /* webpackChunkName: "locale_en_46json_fb361ab1" */),
      cache: true
    },
    {
      key: "locale_en_46json_8bb68802",
      load: () => import("#nuxt-i18n/8bb68802" /* webpackChunkName: "locale_en_46json_8bb68802" */),
      cache: true
    },
    {
      key: "locale_en_46json_a619cb18",
      load: () => import("#nuxt-i18n/a619cb18" /* webpackChunkName: "locale_en_46json_a619cb18" */),
      cache: true
    },
    {
      key: "locale_en_46json_dcc6fb43",
      load: () => import("#nuxt-i18n/dcc6fb43" /* webpackChunkName: "locale_en_46json_dcc6fb43" */),
      cache: true
    },
    {
      key: "locale_en_46json_fd8ca703",
      load: () => import("#nuxt-i18n/fd8ca703" /* webpackChunkName: "locale_en_46json_fd8ca703" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "da",
    language: undefined
  },
  {
    code: "en",
    language: undefined
  }
]

